// extracted by mini-css-extract-plugin
module.exports = {"formColumn":"FormColumn_formColumn__rLxxB","header":"FormColumn_header__3RAPm","additional":"FormColumn_additional__2ENj0","children":"FormColumn_children__2QGO0"};